import React, { Component } from 'react';
import { UsageData } from '../../store/index';

type Props = {
  updateUsageData: (usageData: UsageData) => void;
  usageData: UsageData;
  userType: string;
  isCompany: boolean;
  maximumResolution: string;
};

type State = {
  level: string;
  maximumResolution: string;
};

class TimeStepSelector extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      level: this.props.usageData.level,
      maximumResolution: this.props.maximumResolution
    };
  }
  //e: React.ChangeEvent<HTMLInputElement>
  setTimestep = (timestep: string): void => {
    this.setState({ level: timestep });
    this.handleLevelChange(timestep);
  };

  handleLevelChange = (level: string): void => {
    const { usageData } = this.props;
    this.props.updateUsageData({
      ...usageData,
      level
    });
  };

  render(): JSX.Element {
    return (
      <div className="timestep-selector-container">
        <legend>Valitse aika-askeleen resoluutio</legend>
        <fieldset className="timestep-selector">
          <label
            className={this.props.usageData.level === 'day' ? 'selected' : ''}
            htmlFor="day"
            onClick={this.props.usageData.frame === 'day' ? undefined : () => this.setTimestep('day')}
          >
            Päivä
            <input defaultChecked={this.state.level === 'day'} type="radio" name="day" value="day"></input>
          </label>

          <label
            className={this.props.usageData.level === 'hour' ? 'selected' : ''}
            htmlFor="hour"
            onClick={() => this.setTimestep('hour')}
          >
            Tunti <input defaultChecked={this.state.level === 'hour'} type="radio" name="hour" value="hour"></input>
          </label>
          {this.props.maximumResolution === 'PT15M' && (
            <label
              className={this.props.usageData.level === 'quarter-hour' ? 'selected' : ''}
              htmlFor="quarter-hour"
              onClick={() => this.setTimestep('quarter-hour')}
            >
              Varttitunti
              <input
                defaultChecked={this.state.level === 'quarter-hour'}
                type="radio"
                name="quarter-hour"
                value="quarter-hour"
              ></input>
            </label>
          )}
        </fieldset>
      </div>
    );
  }
}

export default TimeStepSelector;
